export default __webpack_public_path__ + "static/media/github.f76c4e47.svg";